/**
 * Determines if the current device is a mobile device based on the user agent string.
 *
 * Checks the navigator.userAgent against a regex pattern that matches common mobile device identifiers
 * including Android, iOS devices (iPhone, iPad, iPod), and other mobile browsers.
 */
export const isMobile = () => {
  const regex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return regex.test(navigator.userAgent);
};
